import React, { useState, useEffect } from 'react';

import { Dropdown, FormInput_text, FormInput_textarea, formInput_funcUtility, FormGroupRadio, Toaster } from "components";

import { func_validation, func_currency } from "functions";

export function useCompanyInfo(props) {
    // Props
    const {
        isFormSubmissionAttempted
    } = props;
    
    // States
    const [companyName, setCompanyName] = useState("");
    const [companyEmail, setCompanyEmail] = useState("");
    const [name, setName] = useState("");
    const [mobileNo, setMobileNo] = useState("");

    // Display
    let display = (
        <div className="distributorPortal-clientRegistration-companyInfo d-flex">

            {/* Company Name */}
            <FormInput_text  
                inputLabel={"Company Name"}

                className={"distributorPortal-clientRegistration-companyName"}
                inputValue_default={companyName} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setCompanyName(value); }}

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isInputValueTrim_onChange
                isMarginBtmOptional
            />

            {/* Company Email */}
            <FormInput_text  
                inputLabel={"Company Email"}

                className={"distributorPortal-clientRegistration-companyEmail"}
                inputValue_default={companyEmail} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setCompanyEmail(value); }}

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isInputValueTrim_onChange
                isMarginBtmOptional
            />

            {/* Name */}
            <FormInput_text  
                inputLabel={"Name"}

                className={"distributorPortal-clientRegistration-name"}
                inputValue_default={name} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setName(value); }}

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isInputValueTrim_onChange
                isMarginBtmOptional
            />

            {/* Mobile No */}
            <FormInput_text  
                inputLabel={"Mobile No."}

                className={"distributorPortal-clientRegistration-mobileNo"}
                inputValue_default={mobileNo} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setMobileNo(value); }}

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isInputValueTrim_onChange
                isMarginBtmOptional
            />

        </div>
    )

    return {
        companyName,
        companyEmail,
        name,
        mobileNo,
        
        display
    }
}